import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'item', 'noResults']

  search() {
    const searchTerm = this.inputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const name = item.dataset.organizationName?.toLowerCase() || ''
      const id = item.dataset.organizationId?.toLowerCase() || ''

      const matches = !searchTerm || name.includes(searchTerm) || id.includes(searchTerm)

      if (matches) {
        item.style.display = ''
        visibleCount++
      } else {
        item.style.display = 'none'
      }
    })

    if (this.hasNoResultsTarget) {
      if (visibleCount === 0 && searchTerm) {
        this.noResultsTarget.style.display = 'block'
      } else {
        this.noResultsTarget.style.display = 'none'
      }
    }
  }
}
